export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-m.af6ae82c.png";